import { isMobile } from '@platform-shared/utils/device'

export default {
  methods: {
    localize(key, args = []) {
      return isMobile ? this.$localize(key, args) : this.$t(key, args)
    },
  },
}
